import { Component, Input, OnDestroy, OnInit } from '@angular/core';

declare var Contentflow: any;
@Component({
  selector: 'app-contenflow',
  templateUrl: './contenflow.component.html',
  styleUrls: ['./contenflow.component.scss']
})
export class ContenflowComponent implements OnInit, OnDestroy {
  @Input() outputId;
  private player;

  constructor() {}

  ngOnInit(): void {
    this.player = Contentflow.setup({
      corporationId: 'zpFY4CTOksEbpLwZJvsO',
      element: document.getElementById('parent-div-contentflow'),
      outputId: this.outputId,
      disableFallback: true,
      playback: { autoplay: true, muted: false, noBranding: true }
    });
  }

  ngOnDestroy(): void {
    const videos = document.getElementsByTagName('video');
    if (videos) {
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < videos.length; index++) {
        const element: any = videos[index];
        console.log(element);
        element.pause();
        element.removeAttribute('src'); // empty source
        element.load();
      }
    }
    try {
      this.player.destroy();
    } catch (error) {
      console.log(error);
    }
  }
}
